(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('memoryStorage', memoryStorage);

    memoryStorage.$inject = [];
    function memoryStorage() {
        MemoryStorage.constructor = MemoryStorage;
        MemoryStorage.prototype = {};
        Object.defineProperties(MemoryStorage.prototype, {
            length: { get: getLength },
            clear: { value: clear },
            getItem: { value: getItem },
            key: { value: key },
            removeItem: { value: removeItem },
            setItem: { value: setItem }
        });
        return new MemoryStorage();

        /////////////////////////////////////////////

        function MemoryStorage() {}

        function getLength() {
            return Object.keys(this).length;
        }
        function clear() {
            Object.keys(this).forEach(removeItem, this);
        }
        function getItem(id) {
            return this.hasOwnProperty(id) ? this[id] : undefined;
        }
        function key(number) {
            return Object.keys(this)[number];
        }
        function removeItem(id) {
            return delete this[id];
        }
        function setItem(id, val) {
            return this[id] = String(val);
        }
    }
})();